<template>
  <section>
    <PageTitle>
      <span v-html="$store.state.app.pageName" />
    </PageTitle>
    <PageContent>
      <Container>
        <p class="text-xs space-b-4-t space-b-3-m">
          こちらの画面をスタッフへご提示ください
        </p>
        <div class="box">
          <div class="text-center">
            <p class="text-xl text-bold space-b-3">{{ name }} さま</p>
            <VueQrcode
              v-if="token"
              :value="url"
              :options="qrOptions"
            />
          </div>
        </div>
        <p class="text-xs text-light space-t-4">
          ※QRコードは一定時間で更新されますので、スクリーンショットはご利用になれません
        </p>
          <div class="form-footer text-center">
            <WaveButton type="button" class="button" @click="reload">
              リロード
            </WaveButton>
          </div>
      </Container>
    </PageContent>
  </section>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'
import memberApi from '@/api/member'
import { renderError } from '@/utils/error'

export default {
  components: {
    VueQrcode
  },
  metaInfo() {
    return {
      title: this.$store.state.app.pageName,
      bodyAttrs: { class: 'member' }
    }
  },
  data() {
    return {
      token: '',
      qrOptions: {
        width: 200,
        margin: 0
      },
      intervalId: ''
    }
  },
  computed: {
    url() {
      const domain = location.hostname

      return `https://${domain}/visit/?id=${this.userId}&token=${this.token}`
    },
    name() {
      return this.$store.getters['auth/name']
    },
    userId() {
      return this.$store.getters['auth/userId']
    }
  },
  methods: {
    async refreshToken() {
      this.token = ''

      try {
        const response = await memberApi.token(this.userId)
        this.token = response.token
      } catch(err) {
        renderError(err)
      }
    },
    reload() {
      this.refreshToken()
    }
  },
  created() {
    this.$withLoading(this.refreshToken)

    // 10分毎に会員証取得APIを呼び出し、QRコードを再表示する
    const tenMinutes = 1000 * 60 * 10
    this.intervalId = setInterval(this.refreshToken.bind(this), tenMinutes)
  },
  destroyed() {
    clearInterval(this.intervalId)
  }
}
</script>
